import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

let timer = null;
const Index = (props) => {
    const { onChange } = props;
    const [ time, setTime ] = useState(5);
    // const navigate = useNavigate();

    useEffect(() => {
        let initTime = 5;

        timer = setInterval(() => {
            initTime -= 1;

            setTime(initTime);
            if (initTime <= 0) {
                onChange('B');
                clearInterval(timer);
            }
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const jump = () => {
        onChange('B');
        clearInterval(timer);
    };

    return (
        <div className={styles.index}>
            {
                time > 0 && <div className={styles.time} onClick={jump}>跳过 {time}s</div>
            }
            <img className={styles.mainTitle} src={require('../../asset/mainTitle.png')} alt="" />
            <img className={styles.btn} src={require('../../asset/mainBtn.png')} alt="" />
            <img className={styles.logo} src={require('../../asset/logo.png')} alt="logo" />
        </div>
    );
};

Index.propTypes = {
    onChange: PropTypes.func
};

export default errorBoundary(Index);
